module.exports = __webpack_public_path__ + "assets/img/work-scheme.fac69952.png";